import { QA_NAME_CONFIRMATION_MINIMIZED_LEAVE } from '../../../../constants/qa'

export const MINIMIZABLE_MODAL_REPLACE_CONFIRMATION = {
  description: 'Modal.MinimizedModalDataWillBeLostConfirmationTextKey',
  qaName: QA_NAME_CONFIRMATION_MINIMIZED_LEAVE,
}
